import React, { useState } from "react";
import api from "../../lib/api";
import { Plus, Trash2, MapPin } from "lucide-react";
import { toast } from "sonner";

export default function EstateProperties({ properties, onChange, isManager }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", address: "", contact: "", notes: "" });

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/estate/properties", f);
      toast.success("Property added");
      setF({ name: "", address: "", contact: "", notes: "" });
      setOpen(false);
      onChange();
    } catch (err) { toast.error("Could not save property"); }
  };

  const remove = async (p) => {
    if (!window.confirm(`Remove ${p.name}?`)) return;
    await api.delete(`/estate/properties/${p.id}`);
    onChange();
  };

  const inp = "w-full h-11 border border-stone-300 px-3 text-sm";
  return (
    <div className="space-y-4" data-testid="estate-properties">
      {isManager && (
        <button data-testid="add-property-btn" onClick={() => setOpen(!open)}
          className="h-11 px-5 bg-[#1F3D34] text-white font-bold uppercase text-xs flex items-center gap-2">
          <Plus size={15} /> Add Property
        </button>
      )}
      {open && (
        <form onSubmit={save} className="bg-white border border-stone-200 p-5 space-y-3 max-w-xl" data-testid="property-form">
          <input data-testid="prop-name" required placeholder="Property name *" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={inp} />
          <input data-testid="prop-address" placeholder="Address" value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} className={inp} />
          <input data-testid="prop-contact" placeholder="Owner / contact" value={f.contact} onChange={(e) => setF({ ...f, contact: e.target.value })} className={inp} />
          <textarea data-testid="prop-notes" placeholder="Notes (gate codes, pets, special instructions…)" rows={2} value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} className="w-full border border-stone-300 p-3 text-sm" />
          <button data-testid="prop-save" className="h-11 px-6 bg-[#1F3D34] text-white font-bold uppercase text-xs">Save Property</button>
        </form>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {properties.map((p) => (
          <div key={p.id} className="bg-white border border-stone-200 p-4" data-testid={`property-${p.id}`}>
            <div className="flex items-start justify-between gap-2">
              <div>
                <div className="font-bold" style={{ fontFamily: "'Fraunces', serif" }}>{p.name}</div>
                {p.address && <div className="text-xs text-stone-500 flex items-center gap-1 mt-0.5"><MapPin size={11} /> {p.address}</div>}
                {p.contact && <div className="text-xs text-stone-500 mt-0.5">{p.contact}</div>}
                {p.notes && <div className="text-xs text-stone-400 mt-1 italic">{p.notes}</div>}
              </div>
              {isManager && (
                <button data-testid={`delete-property-${p.id}`} onClick={() => remove(p)} className="text-stone-300 hover:text-red-500"><Trash2 size={15} /></button>
              )}
            </div>
          </div>
        ))}
        {properties.length === 0 && (
          <div className="col-span-full bg-white border border-stone-200 p-10 text-center text-stone-400 font-bold uppercase text-sm" data-testid="properties-empty">
            No properties yet — add your first estate above
          </div>
        )}
      </div>
    </div>
  );
}
